module.exports = __webpack_public_path__ + "static/media/4.cd113b43.jpg";